if (!customElements.get('pulse-exercise-gallery')) {
  class PulseExerciseGallery extends HTMLElement {
    connectedCallback() {
      this._initAnimations();
      this._initSlider();
    }

    _initAnimations() {
      if (this.dataset.animate === 'false') return;

      const targets = this.querySelectorAll('[data-anim]');
      if (!targets.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            const delay = parseInt(el.dataset.animDelay || '0', 10);
            setTimeout(() => el.classList.add('peg--visible'), delay);
            observer.unobserve(el);
          });
        },
        { threshold: 0.1 }
      );

      targets.forEach((el) => observer.observe(el));
    }

   _initSlider() {
  const track = this.querySelector('.peg__track');
  const progressBar = this.querySelector('.peg__progress-bar');

  if (!track || !progressBar) return;

  const updateProgress = () => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    const progress = maxScroll ? track.scrollLeft / maxScroll : 0;
    const thumbWidth = (track.clientWidth / track.scrollWidth) * 100;

    progressBar.style.width = `${thumbWidth}%`;
    progressBar.style.left = `${progress * (100 - thumbWidth)}%`;
  };

  track.addEventListener('scroll', updateProgress);
  window.addEventListener('resize', updateProgress);

  requestAnimationFrame(updateProgress);
}
  }

  customElements.define('pulse-exercise-gallery', PulseExerciseGallery);
}


document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.peg__link').forEach(wrapper => {

    const video = wrapper.querySelector('.peg__media');
    const playBtn = wrapper.querySelector('.peg__play-btn');

    playBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      // Pause all other videos
      document.querySelectorAll('.peg__media').forEach(v => {
        if (v !== video) {
          v.pause();
          v.controls = false;
          v.closest('.peg__link')?.classList.remove('playing');
        }
      });

      // Show controls BEFORE play
      video.controls = true;
      video.muted = false;

      wrapper.classList.add('playing');

      video.play();
    });

    video.addEventListener('pause', () => {
      if (!video.ended) {
        video.controls = false;
        wrapper.classList.remove('playing');
      }
    });

    video.addEventListener('ended', () => {
      video.controls = false;
      wrapper.classList.remove('playing');
    });

  });

});